import React from "react";
import i18n from "../../../../i18n/i18n";
import Table from "../../../../common/components/shared/table/table";
import Loader from "../../../../common/components/shared/loader/loader";
import {Api} from "../../../../helpers/api";
import {HttpError} from "../../../../common/components/shared/httpError/httpError";
import {AxiosResponse} from "axios";
import {HttpErrorModel} from "../../../../common/models/httpError";
import {FerryOrdersParkingModel} from "../../../models/ferryOrdersParking";
import {ParkingService} from "../../../services/parkingService";
import {Utils} from "../../../../helpers/utils";
import ReloadButton from "../../../../common/components/shared/reloadButton/reloadButton";
import "../parkingList.scss";
import {SortDirection} from "../../../../common/models/table";

interface ParkingListState {
    parkingData: FerryOrdersParkingModel[] | undefined | null;
    response: AxiosResponse<HttpErrorModel[] | any> | undefined;
    currentPage: number;
    isTableLoader: boolean;
    orderBy?: string;
    sortDirection?: SortDirection;
}

export default class FerryOrdersParkingList extends React.Component <any, ParkingListState> {
    private sortableElements = ["ferryName", "arrivalDepartureTime"];

    constructor(props: any) {
        super(props);

        this.state = {
            parkingData: undefined,
            response: undefined,
            currentPage: 0,
            isTableLoader: false,
            orderBy: undefined,
            sortDirection: undefined
        };
    }

    get parkingData() {
        return this.state.parkingData;
    }

    public async componentDidMount() {
        await this.getAllParkings();
    }

    public render(): JSX.Element {
        const properties = ["ferryName", "arrivalDepartureTime", "relationType", "totalNumberOfOrders", "numberOfOrdersInDepo", "numberOfOrdersExitedDepo"];
        const headers = properties.map(key => i18n.t("place.ferryOrdersParkings.headers." + key));

        return (
            <div className="parking-list">
                {this.renderWrapperContent(headers, properties)}
            </div>
        );
    }

    private renderWrapperContent(headers: string[], properties: string[]) {
        if (!Api.isSuccess(this.state.response)) {
            return (
                <HttpError
                    response={this.state.response}
                    cause={i18n.t("place.ferryOrdersParkings.retrievalErrorSuffix")}
                />
            );
        } else {
            if (this.parkingData === undefined) {
                return <Loader/>;
            } else {
                return (
                    <>
                        {this.renderHeader()}
                        <div className="parking-list-content">
                            {this.parkingData && this.parkingData!.length && this.parkingData!.length > 0 ? (
                                <Table
                                    headers={headers}
                                    rows={this.parkingData}
                                    properties={properties}
                                    testId="parking-table"
                                    pageable={true}
                                    renderCell={this.renderCell}
                                    currentPage={this.state.currentPage}
                                    numberOfElements={this.state.parkingData!.length}
                                    isOldPagination
                                    isTableLoader={this.state.isTableLoader}
                                    sortableElements={this.sortableElements}
                                    sortDirection={this.state.sortDirection}
                                    orderBy={this.state.orderBy}
                                    sortingAction={async (orderBy: string, sortDirection: SortDirection) => {
                                        await this.setState({orderBy, sortDirection});
                                        await this.getAllParkings();
                                    }}
                                />
                            ) : (
                                <Table
                                    headers={headers}
                                    rows={[]}
                                    properties={properties}
                                    testId={"parking-table"}
                                    currentPage={this.state.currentPage}
                                    numberOfElements={0}
                                />
                            )}
                        </div>
                    </>
                );
            }
        }
    }

    private renderHeader() {
        return (
            <div className="header">
                <div className="actions">
                    <ReloadButton
                        reloadFunc={this.reload.bind(this)}
                        testId="parking-list-reload-btn"
                    />
                </div>
            </div>
        );
    }

    private renderCell(row: any, property: string): JSX.Element {
        if (property === "relationType") {
            return <>{i18n.t(`relationType.${row[property]}`)}</>;
        } else if (property === "arrivalDepartureTime") {
            return <>{Utils.renderTime(row[property])}</>;
        }

        return row[property];
    }

    private async getAllParkings() {
        this.setState({
            isTableLoader: true
        });

        const response = await ParkingService.getAllParkingsForFerryOrders({
            orderBy: this.state.orderBy,
            sortDirection: this.state.sortDirection
        });

        this.setState({
            parkingData: response?.data?.data || null,
            response,
            currentPage: response?.data?.currentPage,
            isTableLoader: false
        });
    }

    private async reload() {
        this.setState({parkingData: undefined});
        await this.getAllParkings();
    }
}


